(function () {
  'use strict';
  /* Queen Shaped - Find my size: the drawer.
     Chart, estimates and recommendation logic live in assets/qs-size-data.js. */
  var Q = window.QSFit;
  if (!Q) return;
  var SIZES = Q.SIZES, ZONES = Q.ZONES, clamp = Q.clamp;
  var estimate = Q.estimate, recommend = Q.recommend, verdict = Q.verdict;
  var load = Q.load, save = Q.save, options = Q.options, choose = Q.choose;
  var FIG = window.QSFitFigure;

  var dlg, state, step = 1, picked = null;

  function h(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function build() {
    dlg = h('dialog', 'qs-fit');
    var box = document.querySelector('[data-qs-fit-entry]');
    var img = box && box.getAttribute('data-qs-img');
    var ttl = (box && box.getAttribute('data-qs-title')) || '';
    dlg.innerHTML =
      (img ? '<figure class="qs-fit__media"><img src="' + img + '" alt="" loading="lazy"><figcaption>' + ttl + '</figcaption></figure>' : '') +
      '<button class="qs-fit__close" data-x aria-label="Close">&times;</button>' +
      '<div class="qs-fit__inner" data-body></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('[data-x]').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
  }

  function unitRow(id, val, units, active) {
    var u = units.map(function (x) {
      return '<button type="button" data-unit="' + x + '" aria-pressed="' + (x === active) + '">' + x + '</button>';
    }).join('');
    return '<div class="qs-fit__row"><input type="number" inputmode="decimal" id="' + id + '" value="' + (val || '') +
      '"><div class="qs-fit__units" data-units>' + u + '</div></div>';
  }

  function render() {
    var b = dlg.querySelector('[data-body]');
    if (step === 1) {
      b.innerHTML =
        '<p class="qs-fit__eyebrow">Find my size</p><h2>A couple of quick details</h2>' +
        '<p class="qs-fit__sub">We use these to estimate your measurements. You can correct them on the next step, and they stay on this device.</p>' +
        '<div class="qs-fit__field"><label for="qsf-h">Height</label>' + unitRow('qsf-h', state.hRaw, ['cm', 'in'], state.hUnit) + '</div>' +
        '<div class="qs-fit__field"><label for="qsf-w">Weight</label>' + unitRow('qsf-w', state.wRaw, ['kg', 'lb'], state.wUnit) + '</div>' +
        '<p class="qs-fit__err" data-err hidden></p>' +
        '<div class="qs-fit__actions"><button class="qs-fit__btn" data-next>Continue</button></div>';
      wireUnits(b);
    } else if (step === 2) {
      var rows = ZONES.map(function (z) {
        var k = z[0];
        return '<div class="qs-fit__field"><label for="qsf-' + k + '">' + z[1] + ' (cm)</label>' +
          '<div class="qs-fit__slider"><input type="range" min="70" max="190" id="qsf-' + k + '-r" value="' + state.m[k] + '">' +
          '<input type="number" inputmode="numeric" id="qsf-' + k + '" value="' + state.m[k] + '"></div></div>';
      }).join('');
      b.innerHTML =
        '<p class="qs-fit__eyebrow">Step 2 of 2</p><h2>Check your measurements</h2>' +
        '<p class="qs-fit__sub">Estimated from your height and weight. If you have measured yourself, use those numbers instead — the recommendation is only as good as these.</p>' +
        '<div class="qs-fit__stage" data-stage>' + (FIG ? FIG.figure(state.m, null, null) : '') + '</div>' +
        rows +
        '<div class="qs-fit__actions"><button class="qs-fit__btn--ghost qs-fit__btn" data-back>Back</button>' +
        '<button class="qs-fit__btn" data-see>See my size</button></div>';
      ZONES.forEach(function (z) {
        var k = z[0], r = b.querySelector('#qsf-' + k + '-r'), n = b.querySelector('#qsf-' + k);
        function redraw() {
          var st = b.querySelector('[data-stage]');
          if (st && FIG) st.innerHTML = FIG.figure(state.m, null, k);
        }
        r.addEventListener('input', function () { n.value = r.value; state.m[k] = Number(r.value); redraw(); });
        r.addEventListener('focus', redraw);
        n.addEventListener('focus', redraw);
        n.addEventListener('input', function () {
          var v = clamp(+n.value || 0, 70, 190); r.value = v; state.m[k] = v; redraw();
        });
      });
    } else {
      renderResult(b);
    }
  }

  function wireUnits(b) {
    b.querySelectorAll('[data-units]').forEach(function (g) {
      g.addEventListener('click', function (ev) {
        var t = ev.target.closest('[data-unit]');
        if (!t) return;
        g.querySelectorAll('[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === t); });
        var u = t.getAttribute('data-unit');
        if (u === 'cm' || u === 'in') state.hUnit = u; else state.wUnit = u;
      });
    });
  }

  function renderResult(b) {
    var idx = picked == null ? recommend(state.m) : picked;
    var s = SIZES[idx], opts = options();
    var avail = {};
    opts.forEach(function (o) { avail[o.code] = !o.sold; });
    var onProduct = opts.length > 0;
    var here = !onProduct || avail[s.code] != null;

    var marks = {};
    ZONES.forEach(function (z) { marks[z[0]] = verdict(state.m[z[0]], s[z[0]]); });

    var zones = ZONES.map(function (z) {
      var k = z[0], band = s[k], v = state.m[k];
      var lo = 70, hi = 190, pct = function (x) { return ((clamp(x, lo, hi) - lo) / (hi - lo)) * 100; };
      var dot = FIG ? '<i class="qs-fit__dot" style="background:' + FIG.tone(marks[k]) + '"></i>' : '';
      return '<div><div class="qs-fit__zone-top"><span>' + dot + z[1] + ' &middot; ' + v + 'cm</span><span>' +
        marks[k] + '</span></div><div class="qs-fit__track">' +
        '<div class="qs-fit__band" style="inset-inline-start:' + pct(band[0]) + '%;width:' + (pct(band[1]) - pct(band[0])) + '%"></div>' +
        '<div class="qs-fit__pin" style="inset-inline-start:' + pct(v) + '%"></div></div></div>';
    }).join('');

    var alts = SIZES.slice(Math.max(0, idx - 1), idx + 2).map(function (x) {
      var out = onProduct && avail[x.code] !== true;
      return '<button type="button" data-size="' + x.code + '" aria-pressed="' + (x.code === s.code) + '"' +
        (out ? ' disabled' : '') + '>' + x.code + '</button>';
    }).join('');

    b.innerHTML =
      '<p class="qs-fit__eyebrow">Your size</p>' +
      '<div class="qs-fit__result"><p class="qs-fit__size">' + s.code + '</p>' +
      '<p class="qs-fit__equiv">AU ' + s.au + ' &middot; US ' + s.us + '</p></div>' +
      '<div class="qs-fit__readout">' +
      '<div class="qs-fit__fig">' + (FIG ? FIG.figure(state.m, marks, null) : '') + '</div>' +
      '<div class="qs-fit__zones">' + zones + '</div></div>' +
      '<div class="qs-fit__alt"><p>Also try</p><div class="qs-fit__alt-row" data-alts>' + alts + '</div></div>' +
      '<p class="qs-fit__note">Based on body measurements. Between sizes, we suggest the larger — most of our cuts are relaxed rather than close-fitting.</p>' +
      '<button class="qs-fit__link" data-edit>Edit my measurements</button>' +
      '<div class="qs-fit__actions">' +
      (onProduct ? '<button class="qs-fit__btn" data-pick' + (here && avail[s.code] ? '' : ' disabled') + '>' +
        (avail[s.code] ? 'Select size ' + s.code : 'Sold out in ' + s.code) + '</button>'
        : '<button class="qs-fit__btn" data-close>Done</button>') + '</div>';

    b.querySelectorAll('[data-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        picked = SIZES.findIndex(function (x) { return x.code === btn.getAttribute('data-size'); });
        renderResult(b);
      });
    });
  }

  function commit() {
    save({ hRaw: state.hRaw, hUnit: state.hUnit, wRaw: state.wRaw, wUnit: state.wUnit, m: state.m });
    paintEntry();
  }

  function open() {
    if (!dlg) build();
    var saved = load();
    state = saved
      ? { hRaw: saved.hRaw, hUnit: saved.hUnit, wRaw: saved.wRaw, wUnit: saved.wUnit, m: saved.m }
      : { hRaw: '', hUnit: 'cm', wRaw: '', wUnit: 'kg', m: { bust: 100, waist: 82, hip: 107 } };
    step = saved ? 3 : 1;
    picked = null;
    render();
    dlg.showModal();
  }

  /* delegated so re-renders of the result keep working */
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-qs-fit-open]')) { ev.preventDefault(); open(); return; }
    if (!dlg || !dlg.open) return;
    var t = ev.target;
    if (t.closest('[data-next]')) {
      var hv = parseFloat(dlg.querySelector('#qsf-h').value);
      var wv = parseFloat(dlg.querySelector('#qsf-w').value);
      var err = dlg.querySelector('[data-err]');
      if (!hv || !wv) { err.textContent = 'Please fill in both.'; err.hidden = false; return; }
      state.hRaw = hv; state.wRaw = wv;
      var cm = state.hUnit === 'in' ? hv * 2.54 : hv;
      var kg = state.wUnit === 'lb' ? wv * 0.4536 : wv;
      if (cm < 120 || cm > 215 || kg < 35 || kg > 250) {
        err.textContent = 'That does not look right — check the units.'; err.hidden = false; return;
      }
      state.m = estimate(cm, kg);
      step = 2; render();
    } else if (t.closest('[data-back]')) { step = 1; render(); }
    else if (t.closest('[data-see]')) { picked = null; step = 3; commit(); render(); }
    else if (t.closest('[data-edit]')) { step = 1; render(); }
    else if (t.closest('[data-close]')) { dlg.close(); }
    else if (t.closest('[data-pick]')) {
      var idx = picked == null ? recommend(state.m) : picked;
      choose(SIZES[idx].code);
      dlg.close();
    }
  });

  /* ---------- the line under the size picker ---------- */
  function paintEntry() {
    var saved = load();
    document.querySelectorAll('[data-qs-fit-entry]').forEach(function (box) {
      var lbl = box.querySelector('[data-qs-fit-label]');
      if (!lbl) return;
      var rec = document.querySelector('[data-qs-fit-rec]');
      /* The size picker can rebuild itself underneath us - Swatch King replaces
         its container on every variant change - which destroys the re-parented
         line. Recreate it instead of giving up, or it never comes back. */
      if (!rec) {
        rec = document.createElement('p');
        rec.setAttribute('data-qs-fit-rec', '');
        rec.hidden = true;
        box.insertBefore(rec, box.firstChild);
      }
      /* The recommendation belongs with the sizes, not with the links below them. */
      var fs = Q.sizeAnchor();
      if (fs && rec.parentElement !== fs) {
        rec.className = 'qs-fit-rec';
        fs.appendChild(rec);
      }
      if (!saved || !saved.m) { rec.hidden = true; lbl.textContent = 'Find my size'; return; }
      var s = SIZES[recommend(saved.m)];
      var opts = options(), sold = false, listed = opts.length === 0;
      opts.forEach(function (o) { if (o.code === s.code) { listed = true; sold = o.sold; } });
      rec.innerHTML = listed && !sold
        ? 'We recommend size <b>' + s.code + '</b>'
        : 'Your size <b>' + s.code + '</b> is not available on this style';
      rec.hidden = false;
      lbl.textContent = 'Check my fit';
    });
  }

  function run() { paintEntry(); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('variant:update', run);
})();
